<template>
  <div class="main-layout">
    <layout-header :title="$route.meta.title || '达州市高新区能源信息大数据平台'" />
    <!--    <transition name="el-fade-in-linear">-->
    <!--      <router-view />-->
    <!--    </transition>-->
    <router-view />
  </div>
</template>

<script>
import LayoutHeader from '@/components/Layout/hearder'
export default {
  name: 'Layout',
  components: {
    LayoutHeader
  },
  watch: {
    '$route.meta': {
      handler(newV, oldV) {
        document.title = newV.title || '达州市高新区能源信息大数据平台'
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.$store.dispatch('getParkData')
    this.$store.dispatch('getAgencyList')
    this.$store.dispatch('login')
  }
}
</script>

<style lang="less" scoped>
  .main-layout{
    width: 1920px;
    min-height: 1440px;
    background: url("~@/assets/data-bg.png") left top no-repeat;
    background-size: cover;
  }
</style>
